<template>
    <div class="locker-code-container">
        <h2>
            {{ $t('confirmation.number') }}:
        </h2>

        <span class="locker-code-field">{{ locker.locker_number }}</span>

        <template v-if="locker.zone">
            <h2>
                {{ $t('confirmation.zone') }}:
            </h2>

            <span class="locker-zone-field">{{ locker.zone }}</span>
        </template>

        <h2>
            {{ $t('confirmation.pinCode') }}:
        </h2>

        <span class="locker-code-field">{{ locker.code }}</span>
    </div>
</template>

<script>
    export default {
        props: [
            'locker',
            'lockerSize'
        ]
    }
</script>
